/**
 * Created by - Ashlekh on 04-04-2025
 * Reason - Matrimonial Registration form
 */

import { useEffect, useState, useContext } from "react";
import style from "./MatrimonialRegistrationForm.module.css";
import parse from "html-react-parser";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import { GlobalContext } from "../../context/Context";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const MatrimonialRegistrationForm = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [showContent, setShowContent] = useState(false);
  const initialValues = {
    name: "",
    countryCode: "+91",
    contact_number: "",
    email: "",
    query: "",
  };
  // Added by - Ashlekh on 04-04-2025
  // Reason - This useEffect will executes when page loads
  useEffect(() => {
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Matrimony", path: "/matrimony_registration_form" },
    ]);
    window.scrollTo(0, 0);
    getMatriMonialDetails();
  }, []);
  // End of code - Ashlekh on 04-04-2025
  // Reason - This useEffect will executes when page loads

  const getMatriMonialDetails = async () => {
    try {
      console.log("");
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setShowContent(true);
    }
  };

  const validationSchema = Yup.object({
    contact_number: Yup.number()
      .transform((value, originalValue) =>
        /\s/.test(originalValue) ? NaN : value
      )
      .integer()
      .typeError("Please enter 10 digit mobile number ")
      .required("Please enter mobile number")
      .min(1000000000, "Please enter 10 digit mobile number ")
      .max(9999999999, "Please enter 10 digit mobile number "),

    name: Yup.string()
      .matches(
        /^[a-zA-Z0-9\u0900-\u097F\s]+$/,
        "Please remove special characters"
      )
      .required("Please enter name"),
    email: Yup.string().trim().email("Please enter email in correct format"),
  });

  const renderError = (message) => (
    <span className={`${style.validationMsgContainer}`}>{message}</span>
  );

  const onSubmit = (values) => {};
  return (
    <div>
      {showContent ? (
        <div className={`${style.mainContainer}`}>
          <NavigationPath navigationPathArray={navigationPath} />
          <div className={`${style.pageTitle}`}>Registration Form</div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
              await onSubmit(values);
              resetForm();
            }}
            enableReinitialize={true}
          >
            <Form noValidate={true}>
              <div className={`${style.formContainer}`}>
                <div className={`${style.personalInformationTitle}`}>
                  Personal Information
                </div>
                <div className={`${style.firstRowContainer}`}>
                  <div className={`${style.firstInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Name <span style={{ color: "red" }}>*</span>
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="name"
                          type="text"
                          placeholder="Name"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="name" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.secondInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Mobile Number <span style={{ color: "red" }}>*</span>
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="mobile_number"
                          type="number"
                          placeholder="Mobile Number"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage
                          name="mobile_number"
                          render={renderError}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.thirdInputField}`}>
                    <div className={`${style.labelContainer}`}>Email</div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="email"
                          type="text"
                          placeholder="Emailr"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="email" render={renderError} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style.secondRowContainer}`}>
                  <div className={`${style.firstInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Gender <span style={{ color: "red" }}>*</span>
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          as="select"
                          name="gender"
                          className={`${style.inputBox}`}
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Others">Others</option>
                        </Field>
                        <ErrorMessage name="gender" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.secondInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Date of birth{" "}
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="date_of_birth"
                          type="text"
                          placeholder="Date of birth"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage
                          name="date_of_birth"
                          render={renderError}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.thirdInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Time Of Birth
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="birth_time"
                          type="text"
                          placeholder="Time Of Birth"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="birth_time" render={renderError} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style.thirdRowContainer}`}>
                  <div className={`${style.firstInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Age
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="age"
                          type="text"
                          placeholder="Age"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="age" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.secondInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Marital Status <span style={{ color: "red" }}>*</span>
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          as="select"
                          name="marital_status"
                          className={`${style.inputBox}`}
                        >
                          <option value="">Select Marital Status</option>
                          <option value="Single">Single</option>
                          <option value="Divorced">Divorced</option>
                          <option value="Widowed">Widowed</option>
                        </Field>
                        <ErrorMessage
                          name="marital_status"
                          render={renderError}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.thirdInputField}`}>
                    <div className={`${style.labelContainer}`}>Complexion </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="complexion"
                          type="text"
                          placeholder="Complexion"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="complexion" render={renderError} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style.fourthRowContainer}`}>
                  <div className={`${style.firstInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Blood Group{" "}
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="blood_group"
                          type="text"
                          placeholder="Blood Group"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="blood_group" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.secondInputField}`}>
                    <div className={`${style.labelContainer}`}>Religion </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="religion"
                          type="text"
                          placeholder="Religion"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="religion" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.thirdInputField}`}>
                    <div className={`${style.labelContainer}`}>Caste </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="caste"
                          type="text"
                          placeholder="Caste"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="caste" render={renderError} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style.fifthRowContainer}`}>
                  <div className={`${style.firstInputField}`}>
                    <div className={`${style.labelContainer}`}>Rashi</div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="rashi"
                          type="text"
                          placeholder="Rashi"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="rashi" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.secondInputField}`}>
                    <div className={`${style.labelContainer}`}>Height</div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="height"
                          type="text"
                          placeholder="Height"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="height" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.thirdInputField}`}>
                    <div className={`${style.labelContainer}`}>Weight</div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="weight"
                          type="text"
                          placeholder="Weight"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="weight" render={renderError} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style.sixthRowContainer}`}>
                  <div className={`${style.firstInputField}`}>
                    <div className={`${style.labelContainer}`}>Profession</div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="profession"
                          type="text"
                          placeholder="Profession"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="profession" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.secondInputField}`}>
                    <div className={`${style.labelContainer}`}>Education</div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="education"
                          type="text"
                          placeholder="Education"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="education" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.thirdInputField}`}>
                    <div className={`${style.labelContainer}`}>Income</div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="income"
                          type="text"
                          placeholder="Income"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="income" render={renderError} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style.someMoreInformationTitle}`}>
                  Some more information
                </div>
                <div className={`${style.seventhRowContainer}`}>
                  <div className={`${style.firstInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Father's Name
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="father_name"
                          type="text"
                          placeholder="Father's Name"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="father_name" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.secondInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Mother's Name
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="mother_name"
                          type="text"
                          placeholder="Mother's Name"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="mother_name" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.thirdInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Sister's Name
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="sister_name"
                          type="text"
                          placeholder="Sister's Name"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="sister_name" render={renderError} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style.eighthRowContainer}`}>
                  <div className={`${style.firstInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Father's Occupation
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="father_occupation"
                          type="text"
                          placeholder="Father's Occupation"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage
                          name="father_occupation"
                          render={renderError}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.secondInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Mother's Occupation
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="mother_occupation"
                          type="text"
                          placeholder="Mother's Occupation"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage
                          name="mother_occupation"
                          render={renderError}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.thirdInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Sister's Occupation
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="sister_occupation"
                          type="text"
                          placeholder="Sister's Occupation"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage
                          name="sister_occupation"
                          render={renderError}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style.ninthRowContainer}`}>
                  <div className={`${style.firstInputField}`}>
                    <div className={`${style.labelContainer}`}>Brother(s)</div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="brothers"
                          type="text"
                          placeholder="Brother(s)"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="brothers" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.secondInputField}`}>
                    <div className={`${style.labelContainer}`}>
                      Brother(s) Occupation
                    </div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="brothers_occupation"
                          type="text"
                          placeholder="Brother(s) Occupation"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage
                          name="brothers_occupation"
                          render={renderError}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style.hobbiesAndPreferencesTitle}`}>
                  Hobbies And Preferences
                </div>
                <div className={`${style.tenthRowContainer}`}>
                  <div className={`${style.firstInputField}`}>
                    <div className={`${style.labelContainer}`}>Hobbies</div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="hobbies"
                          type="text"
                          placeholder="Hobbies"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="hobbies" render={renderError} />
                      </div>
                    </div>
                  </div>
                  <div className={`${style.secondInputField}`}>
                    <div className={`${style.labelContainer}`}>Preferences</div>
                    <div className={`${style.inputHolder}`}>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="preferences"
                          type="text"
                          placeholder="Preferences"
                          className={`${style.inputBox}`}
                        />
                        <ErrorMessage name="preferences" render={renderError} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button className={`${style.button}`} type="submit">
                Submit
              </button>
            </Form>
          </Formik>
        </div>
      ) : (
        <div className={style.loaderContent}>
          <img style={{ height: "30vh" }} src="/adyant_loader.gif" />
        </div>
      )}
    </div>
  );
};
export default MatrimonialRegistrationForm;
